import { useEffect, useState } from "react";

/**
 * See https://usehooks.com/useDebounce/
 * @param value
 * @param delay
 * @returns
 */
const useDebounce = (value, delay: number = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
